module.exports = __webpack_public_path__ + "485fa66ed5fe1be6fbbc8ed4fe2d6ba6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/owl-dobe-desert-casa-empty.png
// module id = 320
// module chunks = 0